import {ChangeDetectionStrategy, Component, inject, Input} from "@angular/core";
import {ListPage} from "../../../../../shared/pages/list.page";
import {FormGroup} from "@angular/forms";
import {catchError} from "rxjs";
import {AdminHardwareService} from "../../../../../core/services/admin/admin-hardware.service";
import {NotificationService} from "../../../../../core/services/notification.service";

@Component({
  selector: 'app-hardware-form',
  templateUrl: './hardware-form.component.html',
  styleUrls: ['./hardware-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class HardwareFormComponent extends ListPage {

  readonly NONE_VALUE = 0;

  readonly #hardwareService = inject(AdminHardwareService);
  readonly #notificationService = inject(NotificationService);

  private _formGroupForm!: FormGroup;

  get formGroupForm(): FormGroup {
    return this._formGroupForm;
  }

  @Input({required: true})
  set formGroupForm(value: FormGroup) {
    this._formGroupForm = value;
  }

  readonly availableHardware$ = this.#hardwareService.getAvailableHardware().pipe(
    catchError(error => {
      this.#notificationService.showNotification(
        error.error.message,
        "error"
      )
      return [];
    })
  );
}
